/** 
*@author: Sirisha.M
*@Description : 
**/
/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from 'react';
import cloneDeep from 'lodash.clonedeep';
import ReactEcharts from '../Dashboard/ChartComponents/Echarts/Echarts';

const GraphView = (props) => {
    const getOption = (panelData) => {
        let option = {
            animation: false,
            title: {},
            legend: {
                icon: 'roundRect',
                textStyle: {
                    color: 'black',
                    fontSize: 16
                }
            },
            // color: panelData.colors,
            tooltip: {
                trigger: 'axis'
            },
            xAxis: [
                {
                    gridIndex: 0,
                    min: -1,
                    max: 1600,
                    name: 'Frequency[Hz]',
                    nameLocation: 'center',
                    nameGap: '25',
                    lineStyle: {
                        color: 'white'
                    },
                    axisLabel: {
                        show: true,
                        inside: false,
                        rotate: 0,
                        showMinLabel: null,
                        showMaxLabel: null,
                        margin: 8,
                        fontSize: 15
                    }
                },
                {
                    gridIndex: 1,
                    min: -1,
                    max: 1600,
                    name: 'Frequency[Hz]',
                    nameLocation: 'center',
                    nameGap: '25',
                    lineStyle: {
                        color: 'white'
                    },
                    axisLabel: {
                        show: true,
                        inside: false,
                        rotate: 0,
                        showMinLabel: null,
                        showMaxLabel: null,
                        margin: 8,
                        fontSize: 15
                    }
                },
                {
                    gridIndex: 2,
                    min: -1,
                    max: 1600,
                    name: 'Frequency[Hz]',
                    nameLocation: 'center',
                    nameGap: '25',
                    lineStyle: {
                        color: 'white'
                    },
                    axisLabel: {
                        show: true,
                        inside: false,
                        rotate: 0,
                        showMinLabel: null,
                        showMaxLabel: null,
                        margin: 8,
                        fontSize: 15
                    }
                }
            ],
            yAxis: [
                {
                    ...(panelData && panelData.trendData.xRanges),
                    name: `X – (m/s^2)`,
                    nameLocation: 'center',
                    nameGap: '45',
                    lineStyle: {
                        color: 'white'
                    },
                    axisLabel: {
                        show: true,
                        inside: false,
                        rotate: 0,
                        showMinLabel: null,
                        showMaxLabel: null,
                        margin: 8,
                        fontSize: 15
                    }
                },
                {
                    ...(panelData && panelData.trendData.yRanges),
                    name: `Y – (m/s^2)`,
                    nameLocation: 'center',
                    nameGap: '45',
                    lineStyle: {
                        color: 'white'
                    },
                    axisLabel: {
                        show: true,
                        inside: false,
                        rotate: 0,
                        showMinLabel: null,
                        showMaxLabel: null,
                        margin: 8,
                        fontSize: 15
                    }
                },
                {
                    ...(panelData && panelData.trendData.zRanges),
                    name: `Z – (m/s^2)`,
                    nameLocation: 'center',
                    nameGap: '45',
                    lineStyle: {
                        color: 'white'
                    },
                    axisLabel: {
                        show: true,
                        inside: false,
                        rotate: 0,
                        showMinLabel: null,
                        showMaxLabel: null,
                        margin: 8,
                        fontSize: 15
                    }
                }
            ],
            grid: [
                { left: '7%', top: '7%', width: '90%', height: '20%' },
                { left: '7%', bottom: '40%', width: '90%', height: '20%' },
                { left: '7%', bottom: '7%', width: '90%', height: '20%' }
                // { right: '7%', bottom: '7%', width: '38%', height: '38%' }
            ],
            toolbox: {
                showTitle: false,
                orient: 'vertical',
                itemSize: 25,
                feature: {
                    saveAsImage: {
                        title: 'download',
                        name:
                            props.graphprops && props.graphprops.title
                                ? props.graphprops.title
                                : '',
                        iconStyle: {
                            borderColor: '#fffff',
                            borderWidth: 2
                        }
                    }
                }
            }
        };
        return option;
    };
    const [option, setOption] = useState(getOption(props.panelData));
    //   const [data, setData] = useState([]);
    const [graphType, setGraphType] = useState('bar');
    //   const [language, setLanguage] = useState(props.language || 'English');
    //   const [reportName, setReportName] = useState('');

    useEffect(() => {
        prepareData('bar');
    }, []);

    useEffect(() => {
        if (graphType !== 'bar') {
            prepareData('bar');
        }
    }, [graphType]);

    useEffect(() => {
        if (props.panelData !== undefined) {
            prepareData('bar');
        }
    }, [props.panelData]);

    const prepareData = async (type) => {
        const { panelData } = props;
        let option = cloneDeep(getOption(panelData));
        let xaxis = [],
            series = [],
            finalArray = panelData && panelData.trendData.FFTOutPut;
        let yAxis = [];
        yAxis.push(panelData && panelData.trendData.xRanges);
        yAxis.push(panelData && panelData.trendData.yRanges);
        yAxis.push(panelData && panelData.trendData.zRanges);
        
        if (finalArray) {
            Object.keys(finalArray).forEach((key, index) => {
                const seriesObj = {
                    name: ['X', 'Y', 'Z'][index],
                    type: type,
                    xAxisIndex: index,
                    yAxisIndex: index,
                    data: Array.isArray(finalArray[key]) ? finalArray[key] : [],
                    animationDuration: 0
                };
                series.push(seriesObj);
            });
        }
        

        option.xAxis.data = xaxis;
        option.series = series;

        setOption(option);
        // setReportName(reportName && reportName.file ? reportName.file : '');
    };


    return (
        <React.Fragment>
            <ReactEcharts
                option={option}
                lazyUpdate={false}
                style={{ height: '600px', width: '100%', marginTop: '20px' }}
                className="react_for_echarts"
            />
        </React.Fragment>
    );
};

export default GraphView;
